import { sendRequest } from "../base.service"

export const getFooterList = () => {
    return sendRequest('/home/footer');
}
export const getVSATFooterList = () => {
    return sendRequest('/vsat/footer');
}
export const getPartnersFooterList = () => {
    return sendRequest('/partner/footer');
}
export const getRetiredFooterList = () => {
    return sendRequest('/retired/footer');
}
export const getEnglishFooterList = () => {
    return sendRequest('/home/en/footer');
}